module.exports = __webpack_public_path__ + "img/15.3129943f.svg";